import {Flex} from 'antd';
import React, {ReactElement} from 'react';

import sumTableValue from '../../../../components/Table/Utils/sumTableValue';
import {formatIndian} from '../../../../utils/formatIndian';
import {roundToDecimal} from '../../../netZero/constants/commonFunctions';

import {DataConfig} from './CommonData';

const ChartWithLabel: React.FC<{
  data: DataConfig[];
  title?: string;
  component: ReactElement;
}> = ({data, title = 'TOTAL EMISSIONS', component}) => {
  return (
    <Flex className="labelFlex">
      <Flex className="chartTitle">
        <div className="labelText">{title}</div>
        <div className="unitText">
          <span className="numberText">
            {formatIndian(
              roundToDecimal(sumTableValue(data, 'value', false) as number, 2)
            )}
          </span>
          <span className="numberText">{' tCO2e'}</span>
        </div>
      </Flex>
      <div className="chartCanvas">{component}</div>
    </Flex>
  );
};

export default ChartWithLabel;
